import Box from '@carrier-io/air-react/Box';
import VendorDefLogoIcon from './icons/vendor-deflogo-icon';

export const VendorLogo = () => {
  return (
    <Box
      style={{
        border: 'solid 1px #E0E0E0',
        backgroundColor: '#FAFAFA',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '4px',
        width: '120px',
        height: '120px',
      }}
    >
      <VendorDefLogoIcon />
    </Box>
  );
};
